import { theme } from '@superhi/design'
import styled from 'styled-components'

const SPACING = 16

export const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  @media ${theme.breakpoints.large} {
    flex-wrap: nowrap;
  }
`

type ItemProps = {
  $padding: string
}

export const Item = styled.div<ItemProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 0 ${SPACING / 2}px;
  width: calc(33.333% - ${SPACING}px);
  padding: ${({ $padding }) => $padding};

  &:nth-last-child(1),
  &:nth-last-child(2) {
    display: none;
  }

  @media ${theme.breakpoints.medium} {
    margin: 0 ${SPACING / 2}px;
    width: calc(20% - ${SPACING}px);

    &:nth-last-child(2) {
      display: block;
      width: calc(20% - ${SPACING}px);
    }

    &:nth-last-child(1) {
      display: none;
    }
  }

  @media ${theme.breakpoints.large} {
    margin: 0 ${SPACING}px;
    width: calc(25% - ${SPACING * 2}px);

    &:nth-last-child(1),
    &:nth-last-child(2) {
      display: block;
      width: calc(25% - ${SPACING * 2}px);
    }
  }

  img {
    display: block;
    max-width: 100%;
    width: 80px;
    margin: 0 auto;

    @media ${theme.breakpoints.large} {
      width: 100px;
    }
  }
`
